import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { getStarVariants, TrustpilotStar } from "@/components/custom/ProductBuilder/TrustpilotStar";
import type { TrustpilotRating } from "@/services/TrustpilotClient";
interface Props {
  data: TrustpilotRating;
}
export function FooterReviews(t0) {
  const $ = _c(23);
  const {
    data
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== data.rating || $[1] !== data.ratingLabel) {
    const starVariants = getStarVariants(data.rating, 5);
    t4 = "https://www.trustpilot.com/review/stickergiant.com";
    t5 = "_blank";
    t6 = "noopener noreferrer";
    t7 = "flex flex-col items-center justify-center gap-6 p-8 no-underline! hover:opacity-100!";
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="flex flex-col items-center text-center"><p className="text-sm font-semibold">Satisfaction Guaranteed</p><p className="text-xs font-normal">Reviews powered by</p></div>;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    t1 = "flex items-center gap-1";
    t2 = <span className="sr-only">{data.ratingLabel}, {data.rating} out of 5 stars</span>;
    t3 = starVariants.map(_temp);
    $[0] = data.rating;
    $[1] = data.ratingLabel;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t9 = <div className={t1}>{t2}{t3}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Image src="/trustpilot-logo.svg" alt="Trustpilot" width={120} height={29} className="brightness-0 invert" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t11 = <a href={t4} target={t5} rel={t6} className={t7}>{t8}{t9}{t10}</a>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
function _temp(variant, i) {
  return <TrustpilotStar key={`footer-trustpilot-star-${i}-${variant}`} variant={variant} className="h-10 w-10" />;
}